import gql from 'graphql-tag';

export const UsersContentAccessQuery = gql`
	query UsersContentAccessQuery(
		$accessType: ResourceAccessType!
		$accountIds: [String]!
		$cloudId: ID!
		$contentId: ID!
	) {
		confluence_userContentAccess(
			accessType: $accessType
			accountIds: $accountIds
			cloudId: $cloudId
			contentId: $contentId
		) {
			canAccessList
			cannotAccessList
		}
	}
`;
